











































import { Component, Prop, Mixins } from "vue-property-decorator";
import AppTextField from "#/components/AppTextField.vue";
import UtilMixin from "@/mixins/utilMixin";
import SearchBase from "@/components/admin_common/SearchBase.vue";
import AxiosMixin from "@/mixins/axiosMixin";
import AppAuthButton from "@/components/admin_common/AppAuthButton.vue";
import { PortalJobsearchRecruitee } from "@/model/portal";

@Component({
  components: {
    AppTextField,
    SearchBase,
    AppAuthButton,
  },
})
export default class extends Mixins(AxiosMixin, UtilMixin) {
  private searchKey = ""; //絞り込み文字列

  /** 求人情報 */
  @Prop({
    type: Array,
    default: () => [],
  })
  readonly items!: PortalJobsearchRecruitee[];

  private headers = [
    { text: "詳細", value: "action" },
    { text: "iBowID", value: "ibow_user_id" },
    { text: "iBowシステムID", value: "system_id" },
    { text: "応募者番号（JST）", value: "jst_no" },
    { text: "名前", value: "name" },
    { text: "ふりがな", value: "name_furigana" },
    { text: "生年", value: "birthday_year" },
    { text: "性別", value: "gender" },
    { text: "iBowメアド", value: "ibow_email" },
    { text: "メアド", value: "email" },
  ];

  /** 詳細ボタンクリック時 */
  private goDetail(id: number) {
    /** 詳細画面へ遷移 */
    this.$router.push({ path: `/jobsearch/jobsearch-recruitee/detail/${id}` });
  }
}
